import * as ProgressPrimitive from "@radix-ui/react-progress"
import * as React from "react"

import { classNames } from "@/utils/classNames"

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    indicatorClassName?: string
  }
>(({ className, indicatorClassName, value, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={classNames(
      "relative h-1.5 w-full overflow-hidden rounded-full bg-grey2",
      className,
    )}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={classNames(
        "h-full w-full flex-1 bg-yellow1 transition-all",
        indicatorClassName,
      )}
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
  </ProgressPrimitive.Root>
))
Progress.displayName = ProgressPrimitive.Root.displayName

export { Progress }
